export const browserName = () => {
    const userAgent = navigator.userAgent;
    let browser = '';

    if (userAgent.indexOf('Firefox') > -1) {
        browser = 'Mozilla Firefox';
    } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
        browser = 'Opera';
    } else if (userAgent.indexOf('Trident') > -1 || userAgent.indexOf('MSIE') > -1) {
        browser = 'Microsoft Internet Explorer';
    } else if (userAgent.indexOf('Edge') > -1) {
        browser = 'Microsoft Edge';
    } else if (userAgent.indexOf('Chrome') > -1) {
        browser = 'Google Chrome';
    } else if (userAgent.indexOf('Safari') > -1) {
        browser = 'Apple Safari';
    } else {
        browser = 'unknown';
    }

    return browser;
};export const browserName = () => {
    const userAgent = navigator.userAgent;
    let browser = '';

    if (userAgent.indexOf('Firefox') > -1) {
        browser = 'Mozilla Firefox';
    } else if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
        browser = 'Opera';
    } else if (userAgent.indexOf('Trident') > -1 || userAgent.indexOf('MSIE') > -1) {
        browser = 'Microsoft Internet Explorer';
    } else if (userAgent.indexOf('Edge') > -1) {
        browser = 'Microsoft Edge';
    } else if (userAgent.indexOf('Chrome') > -1) {
        browser = 'Google Chrome';
    } else if (userAgent.indexOf('Safari') > -1) {
        browser = 'Apple Safari';
    } else {
        browser = 'unknown';
    }

    return browser;
};